const TOKEN_VALID_PATH = '/json/TokenValid';

// 'transient' includes 404, since older on-prem servers lack this endpoint — not an invalid token.
export type KeepAliveOutcome = 'kept-alive' | 'token-invalid' | 'transient';

interface OctopusEnvelope {
  Code?: number;
}

// Uses fetch, not HttpClient, so OAuth2Interceptor's 401 refresh logic can't fire from this check.
export async function performKeepAlive(
  apiEndpoint: string,
  accessToken: string,
): Promise<KeepAliveOutcome> {
  let response: Response;
  try {
    response = await fetch(apiEndpoint + TOKEN_VALID_PATH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
      body: '{}',
    });
  } catch {
    return 'transient';
  }

  // 4xx here is a defensive net; real invalid-token signal is Code:-1 in a 200 body.
  if (response.status >= 500) return 'transient';
  if (response.status === 404) return 'transient';
  if (response.status >= 400) return 'token-invalid';

  let parsed: OctopusEnvelope;
  try {
    parsed = (await response.json()) as OctopusEnvelope;
  } catch {
    return 'transient';
  }

  if (parsed.Code === 0) return 'kept-alive';
  return 'token-invalid';
}
